var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0113636 12V0.363636H4.67045C5.52652 0.363636 6.24053 0.49053 6.8125 0.744318C7.38447 0.998106 7.81439 1.35038 8.10227 1.80114C8.39015 2.24811 8.53409 2.76326 8.53409 3.34659C8.53409 3.80114 8.44318 4.20076 8.26136 4.54545C8.07955 4.88636 7.82955 5.16667 7.51136 5.38636C7.19697 5.60227 6.83712 5.75568 6.43182 5.84659V5.96023C6.875 5.97917 7.28977 6.10417 7.67614 6.33523C8.06629 6.56629 8.38258 6.89015 8.625 7.30682C8.86742 7.7197 8.98864 8.21212 8.98864 8.78409C8.98864 9.40152 8.83523 9.95265 8.52841 10.4375C8.22538 10.9186 7.77652 11.2992 7.18182 11.5795C6.58712 11.8598 5.85417 12 4.98295 12H0.0113636ZM2.47159 9.98864H4.47727C5.16288 9.98864 5.66288 9.85795 5.97727 9.59659C6.29167 9.33144 6.44886 8.97917 6.44886 8.53977C6.44886 8.2178 6.37121 7.93371 6.21591 7.6875C6.06061 7.44129 5.83902 7.24811 5.55114 7.10795C5.26705 6.9678 4.92803 6.89773 4.53409 6.89773H2.47159V9.98864ZM2.47159 5.23295H4.29545C4.63258 5.23295 4.93182 5.17424 5.19318 5.05682C5.45833 4.93561 5.66667 4.76515 5.81818 4.54545C5.97348 4.32576 6.05114 4.0625 6.05114 3.75568C6.05114 3.33523 5.90152 2.99621 5.60227 2.73864C5.30682 2.48106 4.88636 2.35227 4.34091 2.35227H2.47159V5.23295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.d710ea6f76c62f2dee5381aab280ee28.svg";
export { ForwardRef as ReactComponent };